import { createAction } from 'redux-actions'

const ns = 'progress/'

export const getProgress = createAction(`${ns}GET_PROGRESS`)
export const getProgressSuccess = createAction(`${ns}GET_PROGRESS_SUCCESS`)
export const getProgressFail = createAction(`${ns}GET_PROGRESS_FAIL`)

export const setManualEntryProgressType = createAction(`${ns}SET_MANUAL_ENTRY_PROGRESS_TYPE`)
export const setManualEntryPointsLogicId = createAction(`${ns}SET_MANUAL_ENTRY_POINTS_LOGIC_ID`)
export const setProgressType = createAction(`${ns}SET_PROGRESS_TYPE`)
export const setProgressCustomType = createAction(`${ns}SET_PROGRESS_CUSTOM_TYPE`)
export const setProgressPeriod = createAction(`${ns}SET_PROGRESS_PERIOD`)

export const getCustomProgress = createAction(`${ns}GET_CUSTOM_PROGRESS`)
export const getCustomProgressSuccess = createAction(`${ns}GET_CUSTOM_PROGRESS_SUCCESS`)
export const getCustomProgressFail = createAction(`${ns}GET_CUSTOM_PROGRESS_FAIL`)

export const getDailyProgress = createAction(`${ns}GET_DAILY_PROGRESS`)
export const getDailyProgressSuccess = createAction(`${ns}GET_DAILY_PROGRESS_SUCCESS`)
export const getDailyProgressFail = createAction(`${ns}GET_DAILY_PROGRESS_FAIL`)

export const addCustomEntry = createAction(`${ns}ADD_CUSTOM_ENTRY`)

export const refreshChallengeResults = createAction(`${ns}REFRESH_CHALLENGE_RESULTS`)
